import React, { useState, useContext } from "react";
import styles from "./styles/PosSearchTicket.module.css";
import DataContext from "../../../context/DataContext";
import { formatDateToLocalDate } from "../../../utils/utils";
import { calculateValues } from "../../../utils/utils";
import POSDataContext from "../../../context/POSDataContext";
import ButtonExpand from "../button_expand/ButtonExpand";
import { t } from "i18next";
import { ReactComponent as Pointer } from "../../../assets/triangle.svg";
import useNumberFormat from "../../../hooks/useNumberFormat";
import { ReactComponent as IconBill } from "../../../assets/bill-1.svg";
import { ReactComponent as IconTicket } from "../../../assets/ticket.svg";
import { ReactComponent as IconClock } from "../../../assets/clock.svg";
/**
 * SideTicket component
 */
const PosSearchTicketRelated = ({
    ticket,

    currency,

    handleCheckFunction,
    clickedTicketPos,
    handleClickedTicket,
    setClickedInstalmentPos,
    setShowTicketInfo,

    selectedSettlementsPos,
}) => {
    const {
        setCurrentTicketPos,
        setCurrentCategoryPos,
        setTicketTypePos,

        selectedInstalmentsPos,
        selectedTicketsPos,
        isAddHoverPos,
        isInstallemtHoverPos,
    } = useContext(POSDataContext);

    const onClickHandle = () => {
        setClickedInstalmentPos(null);
        setShowTicketInfo(true);
        setTicketTypePos(0);
        setCurrentTicketPos(ticket);
        setCurrentCategoryPos(ticket?.photos[0]?.category);
        handleClickedTicket(ticket?.ticketNo);
    };

    const formatNum = useNumberFormat();

    const total = ticket?.paymentBalance;

    return (
        <>
            <div
                role="button"
                className={`${styles.main_ticket_container} ${
                    styles.top_ticket
                } ${
                    clickedTicketPos === ticket?.ticketNo && styles.clicked
                }  flex-container`}
                onClick={() => onClickHandle()}
            >
                <div
                    className={`${styles.input_check_container} flex-container`}
                >
                    <input
                        data-ticketdate={ticket?.from_DateTime}
                        data-ticketid={ticket?.ticketID}
                        data-transactionid={ticket?.transactionID}
                        data-offences={JSON.stringify(ticket?.offences)}
                        className={`${styles.input_check_element}`}
                        type="checkbox"
                        name={ticket?.ticketNo}
                        id={ticket?.ticketNo}
                        value={total}
                        onClick={handleCheckFunction}
                    />
                    <Pointer
                        className={`${styles.input_check_highlight}  ${
                            (isAddHoverPos &&
                                !selectedInstalmentsPos.length &&
                                !selectedTicketsPos.length) ||
                            (isInstallemtHoverPos === ticket?.caseNo &&
                                !selectedSettlementsPos.includes(
                                    ticket?.caseNo
                                ))
                                ? styles.arrowFadeIn
                                : styles.arrowFadeOut
                        } `}
                    />
                    <label
                        className={`${styles.input_check_label}`}
                        htmlFor={ticket?.ticketNo}
                        aria-label={`Check input for ticket id ${ticket?.ticketNo}`}
                    ></label>
                </div>

                <div className={`${styles.info_container} v-flex-container`}>
                    <div
                        className={`${styles.ticket_info} ${styles.number_tag}`}
                    >
                        <span>
                            <IconTicket
                                className={`${styles.ticket_icon} icon-component`}
                            />
                        </span>
                        {ticket?.ticketNo}
                    </div>
                    <div
                        className={`${styles.ticket_info} ${styles.ticket_hide_info} ${styles.date_tag}`}
                    >
                        <span>
                            <IconClock
                                className={`${styles.ticket_icon} icon-component`}
                            />
                        </span>
                        {formatDateToLocalDate(ticket?.from_DateTime)}
                    </div>
                    <div
                        className={`${styles.ticket_info} ${styles.ticket_hide_info_2nd} ${styles.amount_tag}`}
                    >
                        <span>
                            <IconBill
                                className={`${styles.ticket_icon} icon-component`}
                            />
                        </span>
                        {`${currency}${formatNum(total)}`}
                    </div>
                </div>
            </div>
        </>
    );
};

export default PosSearchTicketRelated;
